
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[category]/card/[cardId]",
      function () {
        return require("private-next-pages/[category]/card/[cardId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[category]/card/[cardId]"])
      });
    }
  